/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* global grecaptcha */

import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  haveSSO,
  authenticate,
  sso,
  logOut,
  showModal,
  hideModal,
  approveKvkk,
  getProfileGeneral,
  getMailMatrix,
  sendEmailNotification,
  checkEmailCode,
  sendMobileNotification,
  checkMobileCode,
  resetPassword,
  saveNewPassword,
} from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import * as Alerts from "components/elements/alerts";
import KVKK from "./kvkk";
import { Trans } from "react-i18next";
import { LOGIN_FORMS, AADLogin, GoogleReCaptcha } from "util/constant";
import i18next from "i18next";
import helpers from "util/helpers";
import queryString from "query-string";
import { api } from "api";

// const INITIAL_STATE = {
//   username: "",
//   password: "",
//   email: "",
//   passwordResetCode: "",
//   newPassword: "",
//   newPasswordAgain: "",
//   error: "",
//   successMessage: "",
//   kvkkUrl: "",
//   bgImage: "fga-login-bg1.jpg",
//   form: LOGIN_FORMS.LOGIN,
// };

const INITIAL_STATE = {
  username: "",
  password: "",
  email: "",
  emailVerificationCode: "",
  passwordResetCode: "",
  newPassword: "",
  newPasswordAgain: "",
  kvkkToken: null,
  error: "",
  successMessage: "",
  bgImage: "fga-login-bg1.jpg",
  form: LOGIN_FORMS.PRELOGIN,
  otpDigits: ["", "", "", "", "", ""],
  otpError: false,
  otpTimer: 300,
};

class Index extends Component {
  state = INITIAL_STATE;

  otpTimerInterval = null;
  otpRefs = Array(6).fill(null).map(() => React.createRef());


  componentDidMount() {
    this.getBackground();



    if (this.props.match.path.includes("/password-reset")) {
      this.setState({
        passwordResetCode: this.props.match.params.code,
        form: LOGIN_FORMS.NEW_PASSWORD,
      });
    }

    if (this.props.match.path.includes("/sso")) {
      let query = queryString.parse(window.location.search);

      let error = query.error;
      let errorDescription = query.error_description;

      if (error || errorDescription) {
        alert(error + " => " + errorDescription);
      } else {
        let code = query.code;
        let state = query.state;
        let sessionState = query.session_state;
        this.props.sso(
          code,
          state,
          sessionState,
          this.props.onProcessBegin,
          this.success,
          this.error
        );
      }
    }

    api.get(`api/profile/get-default-kvkk-version`)
      .then((response) => {
        this.setState({
          kvkkUrl: response.data.data.url
        });
      })
      .catch((err) => {
        console.error(err);
      });

  }

    componentDidUpdate(prevProps, prevState) {
    if (
      prevState.form !== this.state.form &&
      this.state.form === LOGIN_FORMS.PRELOGINEMAIL
    ) {
      this.startOtpTimer();
      setTimeout(() => {
        if (this.otpRefs[0] && this.otpRefs[0].current) {
          this.otpRefs[0].current.focus();
        }
      }, 100);
    }
  }

  componentWillUnmount() {
    this.clearOtpTimer();
  }

  handleSSOCheckSubmit = (e) => {
    e.preventDefault();

    if (this.state.username === null || this.state.username === "") return;

    this.props.haveSSO(
      this.state.username,
      this.props.onProcessBegin,
      (res) => {
        this.props.onProcessEnd();
        if (res.haveSSO) {
          const url = `https://login.microsoftonline.com/${AADLogin.Tenant
            }/oauth2/v2.0/authorize?client_id=${AADLogin.ClientId
            }&response_type=code&redirect_uri=${AADLogin.SignInRedirectUri
            }&response_mode=query&scope=openid%20user.read&state=${helpers.createGuid()}&nonce=${helpers.createGuid()}`;
          console.log(url);
          window.location.replace(url);
        } else {
          this.setState({ form: LOGIN_FORMS.LOGIN });
        }
      },
      this.error
    );
  };

  handleLoginSubmit = (e) => {
    e.preventDefault();

    // eslint-disable-next-line
    grecaptcha.ready(() => {
      // eslint-disable-next-line
      grecaptcha
        .execute(GoogleReCaptcha.SiteKey, {
          action: "login",
        })
        .then((captchaToken) => {
          this.props.authenticate(
            this.state.username,
            this.state.password,
            captchaToken,
            this.props.onProcessBegin,
            this.success,
            this.error
          );
        });
    });
  };


   handlePreLoginSubmit = (e) => {
    // this.setState({ ...INITIAL_STATE });
    e.preventDefault();
    this.props.onProcessBegin();
  
        api
       .post(`/api/auth/PreLogin`,
        {
          username : this.state.username,
          password : this.state.password,
          step : 1
        })
            .then((response) => {
 

              if(response.data.emailstatus)
              {
                    this.setState({ error: null });

            this.success();
               this.setState({
        form: LOGIN_FORMS.PRELOGINEMAIL
      });
              }
              else
              {
                 this.error();
              }



              // this.setState({
              //   positionVideos: response.data.data.positionVideos,
              //   positions: response.data.data.positions,
              // });
            })
            .catch((err) => { 
              this.error(err);
            })
            .finally(() => {
              this.props.onProcessEnd();
            });
            
    // // this.props.authenticate(
    // //   this.state.username,
    // //   this.state.password,
    // //   this.props.onProcessBegin,
    // //   this.success,
    // //   this.error
    // // );
  
    //    // eslint-disable-next-line
    // grecaptcha.ready(() => { 
    //   // eslint-disable-next-line
    //   grecaptcha
    //     .execute(GoogleReCaptcha.SiteKey, {
    //       action: "login",
    //     })
    //     .then((captchaToken) => {
    //       this.props.authenticate(
    //         this.state.username,
    //         this.state.password,
    //         captchaToken,
    //         this.props.onProcessBegin,
    //         this.success,
    //         this.error
    //       );
    //     });
    // });

  };



  success = () => {
    if (!localStorage.getItem("i18nextLng"))
      localStorage.setItem("i18nextLng", "tr-TR");

    this.props.getProfileGeneral(
      this.props.onProcessBegin,
      this.onProfileSuccess,
      this.onProfileError
    );
  };
  error = (err) => {
    let alertContent = "";
    this.props.onProcessEnd();
    if (err.response) {
      alertContent = err.response.data.message;
    } else {
      alertContent = err.toString();
    }

    //KVKK
    if (err.response.data.data && err.response.data.data.kvkkApproveCode) {
      // aydınlatma metnini göster
      this.renderKvkkModal(err.response.data.data.kvkkApproveCode);
    }

    //MAIL
    if (
      err.response.data.data &&
      err.response.data.data.mailEmployeeApproveCode
    ) {
      this.setState({
        mailEmployeeApproveCode: err.response.data.data.mailEmployeeApproveCode,
      });
      // aydınlatma metnini göster
      this.getMailMatrix();
    }

    //MOBILE
    if (
      err.response.data.data &&
      err.response.data.data.mobileEmployeeApproveCode
    ) {
      this.setState({
        mobileEmployeeApproveCode:
          err.response.data.data.mobileEmployeeApproveCode,
      });
      // aydınlatma metnini göster
      this.renderMobileModal();
    }

    this.setState({ error: alertContent });
  };
  onProfileSuccess = (res) => {
    localStorage.setItem("roles", res.roles);
    this.props.history.push("/");
  };
  onProfileError = (err) => {
    console.dir(err);
    this.props.onProcessEnd();
  };
  onGuideFetchBegin = () => {
    this.props.onProcessBegin();
  };
  onGuideFetchError = (err) => {
    console.dir(err);
    this.props.onProcessEnd();
  };
  onGuideFetchSuccess = () => {
    this.props.onProcessEnd();
    this.props.history.push("/");
  };

  handleForgotPasswordSubmit = (e) => {
    e.preventDefault();

    if (this.state.username === null || this.state.username === "") return;

    this.setState({ successMessage: "", error: "" });

    // eslint-disable-next-line
    grecaptcha.ready(() => {
      // eslint-disable-next-line
      grecaptcha
        .execute(GoogleReCaptcha.SiteKey, {
          action: "resetpassword",
        })
        .then((captchaToken) => {
          this.props.resetPassword(
            this.state.username,
            captchaToken,
            this.props.onProcessBegin,
            this.onResetPasswordSuccess,
            this.onResetPasswordError
          );
        });
    });
  };
  onResetPasswordSuccess = () => {
    this.props.onProcessEnd();
    //Şifre güncelleme linkiniz sisteme kayıtlı olan mail adresinize gönderilmiştir = 10397
    this.setState({ successMessage: i18next.t(10397), error: "" });
  };
  onResetPasswordError = (err) => {
    //console.dir(err);
    this.props.onProcessEnd();
    let message = err.response ? err.response.data.message : err.toString();
    this.setState({ successMessage: "", error: message });
  };

  handleNewPasswordSubmit = (e) => {
    e.preventDefault();

    if (this.state.newPassword === null || this.state.newPassword === "")
      return;

    if (
      this.state.newPasswordAgain === null ||
      this.state.newPasswordAgain === ""
    )
      return;

    if (this.state.newPassword !== this.state.newPasswordAgain) {
      //Gidiğiniz şifreler eşleşmemektedir
      this.setState({ successMessage: "", error: i18next.t(10399) });
      return;
    }

    if (!this.props.match.params.code) {
      alert("code is empty");
      return;
    }

    this.props.saveNewPassword(
      this.props.match.params.code,
      this.state.newPassword,
      this.props.onProcessBegin,
      this.onSaveNewPasswordSuccess,
      this.onSaveNewPasswordError
    );
  };
  onSaveNewPasswordSuccess = () => {
    this.props.onProcessEnd();
    //Şifreniz başarılı bir şekilde güncellenmiştir. Yeni şifreniz ile giriş yapabilirsiniz. = 10398
    this.setState({ successMessage: i18next.t(10398), error: "" });
  };
  onSaveNewPasswordError = (err) => {
    console.dir(err);
    this.props.onProcessEnd();
    let message = err.response ? err.response.data.message : err.toString();
    this.setState({ successMessage: "", error: message });
  };

  getMailMatrix = () => {
    this.props.getMailMatrix(
      this.state.username,
      this.props.onProcessBegin,
      this.onMailMatrixSuccess,
      this.onMailMatrixError
    );
  };
  onMailMatrixSuccess = (res) => {
    this.props.onProcessEnd();
    this.renderMailApprovalModal(res);
  };
  onMailMatrixError = (err) => {
    this.props.onProcessEnd();
    this.props.hideModal();
    console.dir(err);

    this.props.showModal({
      modalType: "mailMatrixError",
      modalTitle: "İşlem Başarısız",
      // modalContent: err.data.message,
    });
  };

  getBackground = () => {
    const arrayFGALBg = [
      "fga-login-bg-2025-1.jpg",
      "fga-login-bg-2025-2.jpg",
      "fga-login-bg-2025-3.jpg",
      "fga-login-bg-2025-4.jpg",
      "fga-login-bg-2025-5.jpg",
      "fga-login-bg-2025-6.jpg",
      "fga-login-bg-2025-7.jpg",
      "fga-login-bg-2025-8.jpg",
      "fga-login-bg-2025-9.jpg",
    ];
    const randomFGALBg =
      arrayFGALBg[Math.floor(Math.random() * arrayFGALBg.length)];
    var bgImage = "url('/img/" + randomFGALBg + "')";
    this.setState({ bgImage: bgImage });
  };

  renderKvkkModal = (kvkkApproveCode) => {
    this.props.showModal({
      modalType: "kvkk",
      modalCustomClassName: "modal-90w",
      modalTitle:
        "FORD GELİŞİM AKADEMİSİ KİŞİSEL VERİLERİN KORUNMASI POLİTİKASI",
      modalContent: <KVKK kvkkApproveCode={kvkkApproveCode} />,
      modalFooter: null,
    });
  };

  handleSubmitMailVerificationMailAddress = (e) => {
    e.preventDefault();
    this.props.sendEmailNotification(
      `${this.state.mailApproveUserName}@${this.state.mailApproveDomain}`,
      this.state.mailEmployeeApproveCode,
      this.props.onProcessBegin,
      this.sendMailVerificationSuccess,
      this.sendMailVerificationError
    );
  };
  sendMailVerificationSuccess = (res) => {
    this.props.onProcessEnd();
    this.props.hideModal();
    this.renderCheckCodeModal();
  };
  sendMailVerificationError(err) {
    console.log(err);
  }

  handleSubmitMobileVerificationPhoneNumber = (e) => {
    e.preventDefault();
    this.props.sendMobileNotification(
      this.state.mobileEmployeePhoneNumber,
      this.state.mobileEmployeeApproveCode,
      this.props.onProcessBegin,
      this.sendMobileNotificationSuccess,
      this.sendMobileNotificationError
    );
  };
  sendMobileNotificationSuccess = (res) => {
    this.props.onProcessEnd();
    this.props.hideModal();
    this.renderCheckMobileCodeModal();
  };
  sendMobileNotificationError(err) {
    console.dir(err);
  }

  handleSubmitMailVerificationCheckCode = (e) => {
    e.preventDefault();
    this.props.checkEmailCode(
      this.state.mailApproveCheckCode,
      this.state.mailEmployeeApproveCode,
      this.props.onProcessBegin,
      this.checkEmailCodeSuccess,
      this.checkEmailCodeError
    );
  };

  handleSubmitMobileVerificationCheckCode = (e) => {
    e.preventDefault();
    this.props.checkMobileCode(
      this.state.mobileApprovalCheckCode,
      this.state.mobileEmployeeApproveCode,
      this.props.onProcessBegin,
      this.checkMobileCodeSuccess,
      this.checkMobileCodeError
    );
  };

  checkEmailCodeSuccess = (res) => {
    this.props.onProcessEnd();
    this.props.hideModal();
    this.renderCheckResult();
  };

  checkMobileCodeSuccess = (res) => {
    this.props.onProcessEnd();
    this.props.hideModal();
    this.renderCheckResult();
  };

  renderCheckResult = () => {
    return (
      <div>
        <Trans desc="Doğrulama başrılı, tekrar giriş yapabilirsiniz">
          10535
        </Trans>
      </div>
    );
  };

  checkEmailCodeError = (err) => {
    this.props.onProcessEnd();
    console.dir(err.response.data.message);
    this.setState({ checkEmailCodeError: err.response.data.message });
    this.renderCheckEmailCodeError();
  };

  checkMobileCodeError = (err) => {
    this.props.onProcessEnd();
    console.dir(err.response.data.message);
    this.setState({ checkMobileCodeError: err.response.data.message });
    this.renderCheckMobileCodeError();
  };

  renderCheckEmailCodeError = () => {
    this.props.hideModal();
    this.props.showModal({
      modalType: "checkCodeError",
      modalCustomClassName: "modalMailApproval",
      modalTitle: (
        <strong>
          <Trans desc="Hata Oluştu">10534</Trans>
        </strong>
      ),
      modalContent: <div>{this.state.checkEmailCodeError}</div>,
    });
  };

  renderCheckMobileCodeError = () => {
    this.props.hideModal();
    this.props.showModal({
      modalType: "checkCodeError",
      modalCustomClassName: "modalMailApproval",
      modalTitle: (
        <strong>
          <Trans desc="Hata Oluştu">10534</Trans>
        </strong>
      ),
      modalContent: <div>{this.state.checkMobileCodeError}</div>,
    });
  };

  renderCheckCodeModal = () => {
    this.props.showModal({
      modalType: "mailApproval",
      modalCustomClassName: "modalMailApproval",
      modalTitle: (
        <strong>
          <Trans desc="E-posta Doğrulama Gerekiyor"></Trans>
        </strong>
      ),
      modalContent: (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "210px 210px",
            gridAutoRows: "true",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div>
            <input
              type="text"
              value={this.state.mailApproveCheckCode}
              onChange={(e) =>
                this.setState({ mailApproveCheckCode: e.target.value })
              }
            ></input>
          </div>
          <div>
            <a href="#" onClick={this.handleSubmitMailVerificationCheckCode}>
              <Trans desc="Kodu Onayla">10533</Trans>
            </a>
          </div>
        </div>
      ),
    });
  };

  renderCheckMobileCodeModal = () => {
    this.props.showModal({
      modalType: "mobileApproval",
      modalCustomClassName: "modalMailApproval",
      modalTitle: (
        <strong>
          <Trans desc="Telefon Numarası Doğrulama Gerekiyor">10532</Trans>
        </strong>
      ),
      modalContent: (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "210px 210px",
            gridAutoRows: "true",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div>
            <input
              type="text"
              value={this.state.mobileApprovalCheckCode}
              onChange={(e) =>
                this.setState({ mobileApprovalCheckCode: e.target.value })
              }
            ></input>
          </div>
          <div>
            <a
              href="#"
              onClick={(e) => this.handleSubmitMobileVerificationCheckCode(e)}
            >
              <Trans desc="Kodu Onayla">10533</Trans>
            </a>
          </div>
        </div>
      ),
    });
  };

  renderMobileModal = () => {
    this.props.showModal({
      modalType: "mobileApproval",
      modalCustomClassName: "modalMailApproval",
      modalTitle: (
        <strong>
          <Trans desc="Telefon Numarası Doğrulama Gerekiyor">10532</Trans>
        </strong>
      ),
      modalContent: (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto",
            gridAutoRows: "true",
            alignItems: "center",
            gap: "10px",
            textAlign: "center",
          }}
        >
          <div>
            <input
              type="text"
              value={this.state.mobileEmployeePhoneNumber}
              onChange={(e) =>
                this.setState({ mobileEmployeePhoneNumber: e.target.value })
              }
              style={{ width: "100%", textAlign: "center" }}
            />
          </div>
          <div>
            <Trans desc="Lütfen cep telefonu numaranızı başında ...">
              10553
            </Trans>
            <hr />
          </div>

          <div>
            <a
              href="#"
              onClick={(e) => this.handleSubmitMobileVerificationPhoneNumber(e)}
            >
              <Trans desc="Bu cep telefonuna doğrulama kodunu gönder">
                10530
              </Trans>
            </a>
          </div>
        </div>
      ),
    });
  };

  renderMailApprovalModal = (res) => {
    let options = res.data.data.domains.map((d) => {
      return { value: d, label: d };
    });

    if (options !== null && options.length > 0)
      this.setState({ mailApproveDomain: options[0].value });

    this.props.showModal({
      modalType: "mailApproval",
      modalCustomClassName: "modalMailApproval",
      modalTitle: (
        <strong>
          <Trans desc="E-posta Doğrulama Gerekiyor">10531</Trans>
        </strong>
      ),
      modalContent: (
        <div className="mailApproveModal">
          <div>
            <input
              type="text"
              style={{ width: "100%" }}
              value={this.state.mailApproveUserName}
              onChange={(e) =>
                this.setState({ mailApproveUserName: e.target.value })
              }
            ></input>
          </div>
          <div>@</div>
          <div>
            <Select
              options={options}
              defaultValue={options[0]}
              onChange={(e) => this.setState({ mailApproveDomain: e.value })}
            />
          </div>

          <div
            style={{
              gridColumnStart: "1",
              gridColumnEnd: "4",
              textAlign: "center",
            }}
          >
            <Trans desc="Lütfen mail adresinizin “@”den önceki alanını doldurunuz...">
              10554
            </Trans>
            <hr />
          </div>

          <div
            style={{
              gridColumnStart: "1",
              gridColumnEnd: "4",
              textAlign: "center",
            }}
          >
            <a href="#" onClick={this.handleSubmitMailVerificationMailAddress}>
              <Trans desc="Bu mail adresine doğrulama kodunu gönder!">
                10529
              </Trans>
            </a>
          </div>
        </div>
      ),
    });
  };

  renderError = () => {
    if (this.state.error) {
      return (
        <div
          style={{
            width: "100%",
            height: "120px",
            marginBottom: "10px",
          }}
        >
          {Alerts.RedAlert({ content: this.state.error })}
        </div>
      );
    } else {
      return null;
    }
  };

  renderSuccess = () => {
    if (this.state.successMessage) {
      return (
        <div
          style={{
            width: "100%",
            height: "120px",
            marginBottom: "10px",
          }}
        >
          {Alerts.SuccessAlert({ content: this.state.successMessage })}
        </div>
      );
    } else {
      return null;
    }
  };

  renderFormLogo = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 my-4 text-center">
        <img src="/img/fga-login-logo.png" className="img-fluid" />
      </div>
    );
  };

  renderSSOCheckForm = () => {
    return (
      <form
        autoComplete="false"
        id="ssoForm"
        name="ssoForm"
        onSubmit={(e) => this.handleSSOCheckSubmit(e)}
      >
        <div className="row h-100">
          {this.renderFormLogo()}
          {this.renderError()}
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="form-group" id="usernameArea">
              <label htmlFor="username">
                <Trans desc="Kullanıcı Adı">10355</Trans>
              </label>
              <input
                type="text"
                className="form-control"
                id="username"
                onChange={(e) => this.setState({ username: e.target.value })}
                value={this.state.username}
              />
              <div className="validationArea"></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mt-3 text-right">
            <button className="btn btn-fga-primary">
              <span>
                <Trans desc="Devam Et">10597</Trans>
              </span>
              <span className="icon-icon-login-login"></span>
            </button>
          </div>
          <div className="col-12 my-5 text-center kvkkText">
            {/* 6698 sayılı Kişisel Veri Koruma Kanunu uyarınca şirketin
                    ilgili aydınlatma metnine <a href="#">buradan </a>
                    ulaşabilirsiniz. */}
            <a
              style={{ textDecoration: "none" }}
              href="https://fga-scorm.genbil.com/Assets/KVKK/kvkk-20210406.pdf"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Trans desc="6698 sayılı">10359</Trans>
            </a>
          </div>
        </div>
      </form>
    );
  };

  renderLoginForm = () => {
    return (
      <form
        autoComplete="false"
        id="loginForm"
        name="loginForm"
        onSubmit={(e) => this.handleLoginSubmit(e)}
      >
        <div className="row h-100">
          {this.renderFormLogo()}
          {this.renderError()}
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="form-group" id="usernameArea">
              <label htmlFor="username">
                <Trans desc="Kullanıcı Adı">10355</Trans>
              </label>
              <input
                type="text"
                className="form-control"
                id="username"
                onChange={(e) => this.setState({ username: e.target.value })}
                value={this.state.username}
              />
              <div className="validationArea"></div>
            </div>
            <div className="form-group" id="passwordArea">
              <label htmlFor="password">
                <Trans desc="Şifre">10356</Trans>
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                onChange={(e) => this.setState({ password: e.target.value })}
              />
              <div className="validationArea"></div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 text-right pl-0">
            <a
              href="#"
              onClick={() =>
                this.setState({ form: LOGIN_FORMS.FORGOT_PASSWORD })
              }
            >
              <label className="formClickArea">
                <span className="iconmford fo-icon-lock-outline"></span>
                <span>
                  <Trans desc="Şifremi Unuttum">10357</Trans>
                </span>
              </label>
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mt-3 text-right">
            <button className="btn btn-fga-primary">
              <span>
                <Trans desc="Giriş Yap">10358</Trans>
              </span>
              <span className="iconmford fo-icon-exit-to-app"></span>
            </button>
          </div>

          <div className="col-12 my-5 text-center kvkkText">
            {/* 6698 sayılı Kişisel Veri Koruma Kanunu uyarınca şirketin
                    ilgili aydınlatma metnine <a href="#">buradan </a>
                    ulaşabilirsiniz. */}
            <a
              style={{ textDecoration: "none" }}
              href={this.state.kvkkUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Trans desc="6698 sayılı">10359</Trans>
            </a>
          </div>
        </div>
      </form>
    );
  };

  renderForgotPasswordForm = () => {
    return (
      <form
        autoComplete="false"
        id="emailForm"
        name="emailForm"
        onSubmit={(e) => this.handleForgotPasswordSubmit(e)}
      >
        <div className="row h-100">
          {this.renderFormLogo()}
          {this.renderError()}
          {this.renderSuccess()}
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 forgotPassText text-center">
            <h6>
              <Trans desc="Şifremi Unuttum">10357</Trans>
            </h6>
            <p>
              <Trans desc="Şifrenizi yeniden almak için sisteme kayıtlı kullanıcı adınızı giriniz">
                10395
              </Trans>
            </p>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="form-group">
              <label htmlFor="email">
                <Trans desc="Kullanıcı Adı">10355</Trans>
              </label>
              <input
                type="text"
                className="form-control"
                id="email"
                onChange={(e) => this.setState({ username: e.target.value })}
                value={this.state.username}
              />
              <div className="validationArea"></div>
            </div>
          </div>
          <div className="col-12 text-right pl-0">
            <a
              href="#"
              onClick={() => this.setState({ form: LOGIN_FORMS.LOGIN })}
            >
              <label className="formClickArea">
                <span className="icon-icon-login-login"></span>
                <span>
                  <Trans desc="Giriş Yap">10358</Trans>
                </span>
              </label>
            </a>
          </div>
          <div className="col-12 mt-3 text-right">
            <button className="btn btn-fga-primary">
              <Trans desc="Gönder">10394</Trans>
              <span className="icon-icon-login-login"></span>
            </button>
          </div>
        </div>
      </form>
    );
  };

  renderNewPasswordForm = () => {
    return (
      <form
        autoComplete="false"
        id="newPasswordForm"
        name="newPasswordForm"
        onSubmit={(e) => this.handleNewPasswordSubmit(e)}
      >
        <div className="row h-100">
          {this.renderFormLogo()}
          {this.renderError()}
          {this.renderSuccess()}
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="form-group" id="usernameArea">
              <label htmlFor="password">
                <Trans desc="Şifre">10356</Trans>
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                onChange={(e) => this.setState({ newPassword: e.target.value })}
              />
              <div className="validationArea"></div>
            </div>
            <div className="form-group" id="passwordArea">
              <label htmlFor="password">
                <Trans desc="Şifre Tekrar">10392</Trans>
              </label>
              <input
                type="password"
                className="form-control"
                id="newPasswordAgain"
                onChange={(e) =>
                  this.setState({ newPasswordAgain: e.target.value })
                }
              />
              <div className="validationArea"></div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-8">
            <label>
              <Trans desc="Şifreniz en az 8 karakter olmalıdır. ">10555</Trans>
            </label>
          </div>
          <div className="col-4">
            <a
              href="#"
              onClick={() => this.setState({ form: LOGIN_FORMS.LOGIN })}
            >
              <label className="formClickArea" style={{ minWidth: "80px" }}>
                <span className="icon-icon-login-login"></span>
                <span>
                  <Trans desc="Giriş Yap">10358</Trans>
                </span>
              </label>
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mt-3 text-right">
            <button className="btn btn-fga-primary">
              <span>
                <Trans desc="Kaydet">10393</Trans>
              </span>
              <span className="icon-icon-login-login"></span>
            </button>
          </div>
        </div>
      </form>
    );
  };


     handleEmailVerificationSubmit = (e) => {
    // this.setState({ ...INITIAL_STATE });
    e.preventDefault();
    this.props.onProcessBegin();
  
        api
       .post(`/api/auth/PreLogin`,
        {
          username : this.state.username,
          password : this.state.password,
          step : 2,
          emailVerificationCode : this.state.otpDigits.join("")
          // emailVerificationCode : this.state.emailVerificationCode
        })
            .then((response) => {

                if(response.data.controlstatus)
              {
            
              grecaptcha.ready(() => { 
      // eslint-disable-next-line
      grecaptcha
        .execute(GoogleReCaptcha.SiteKey, {
          action: "login",
        })
        .then((captchaToken) => {
          this.props.authenticate(
            this.state.username,
            this.state.password,
            this.state.otpDigits.join(""),
            captchaToken,
            this.props.onProcessBegin,
            this.success,
            this.error
          );
        });
    });

            // this.success();

              }
              else
              {
                 this.error();
              }
               
      //          this.setState({
      //   form: LOGIN_FORMS.PRELOGINEMAIL
      // });

              // this.setState({
              //   positionVideos: response.data.data.positionVideos,
              //   positions: response.data.data.positions,
              // });
            })
            .catch((err) => {
               this.error(err); 
            })
            .finally(() => {
              this.props.onProcessEnd();
            });
            
    // // this.props.authenticate(
    // //   this.state.username,
    // //   this.state.password,
    // //   this.props.onProcessBegin,
    // //   this.success,
    // //   this.error
    // // );
  
    //    // eslint-disable-next-line
    // grecaptcha.ready(() => { 
    //   // eslint-disable-next-line
    //   grecaptcha
    //     .execute(GoogleReCaptcha.SiteKey, {
    //       action: "login",
    //     })
    //     .then((captchaToken) => {
    //       this.props.authenticate(
    //         this.state.username,
    //         this.state.password,
    //         captchaToken,
    //         this.props.onProcessBegin,
    //         this.success,
    //         this.error
    //       );
    //     });
    // });

  };



   handleResendOtp = () => {
 
     api
       .post(`/api/auth/PreLogin`,
        {
          username : this.state.username,
          password : this.state.password,
          step : 1
        })
            .then((response) => { 

              if(response.data.emailstatus)
              {
                    this.setState({ error: null });  
                

                     this.setState(
    { otpDigits: ["", "", "", "", "", ""], otpError: false },
    () => {
      this.otpRefs[0].current && this.otpRefs[0].current.focus();
    }
  );
  this.startOtpTimer();


              }
              else
              {
                 this.error();
              } 
              // this.setState({
              //   positionVideos: response.data.data.positionVideos,
              //   positions: response.data.data.positions,
              // });
            })
            .catch((err) => { 
              this.error(err);
            })
            .finally(() => {
              this.props.onProcessEnd();
            }); 
  };

  handleOtpChange = (index, value) => {
    const digit = value.slice(-1);
    const newDigits = [...this.state.otpDigits];
    newDigits[index] = digit;
    this.setState({ otpDigits: newDigits, otpError: false }, () => {
      if (digit && index < 5) {
        this.otpRefs[index + 1].current &&
          this.otpRefs[index + 1].current.focus();
      }
    });
  };

  handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !this.state.otpDigits[index] && index > 0) {
      const newDigits = [...this.state.otpDigits];
      newDigits[index - 1] = "";
      this.setState({ otpDigits: newDigits }, () => {
        this.otpRefs[index - 1].current &&
          this.otpRefs[index - 1].current.focus();
      });
    }
  };

  handleOtpPaste = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData)
      .getData("text")
      .slice(0, 6);
    const newDigits = ["", "", "", "", "", ""];
    paste.split("").forEach((c, i) => {
      newDigits[i] = c;
    });
    this.setState({ otpDigits: newDigits, otpError: false }, () => {
      const nextIndex = Math.min(paste.length, 5);
      this.otpRefs[nextIndex].current &&
        this.otpRefs[nextIndex].current.focus();
    });
  };

  startOtpTimer = () => {
    this.clearOtpTimer();
    this.setState({ otpTimer: 300 });
    this.otpTimerInterval = setInterval(() => {
      this.setState((prev) => {
        if (prev.otpTimer <= 1) {
          clearInterval(this.otpTimerInterval);
          return { otpTimer: 0 };
        }
        return { otpTimer: prev.otpTimer - 1 };
      });
    }, 1000);
  };

  clearOtpTimer = () => {
    if (this.otpTimerInterval) {
      clearInterval(this.otpTimerInterval);
      this.otpTimerInterval = null;
    }
  };

  formatOtpTimer = () => {
    const { otpTimer } = this.state;
    const m = String(Math.floor(otpTimer / 60)).padStart(2, "0");
    const s = String(otpTimer % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  renderEmailVerificationForm = () => {
    const { otpDigits, otpTimer } = this.state;
    const isTimerExpired = otpTimer === 0;
    const timerColor = otpTimer <= 60 ? "#dc3545" : "#6c757d";

    return (
      <form onSubmit={(e) => this.handleEmailVerificationSubmit(e)}>
        <div className="row">
          {this.renderFormLogo()}
          {this.renderError()}

          <div className="col-12 text-center mb-3">
            <h5>
              <Trans desc="Email Doğrulama">email_verification</Trans>
            </h5>
            <p style={{ fontSize: "13px", color: "#6c757d" }}>
              <Trans desc="Email adresine gelen kodu giriniz">
                enter_the_code_sent_to_your_email_address
              </Trans>
            </p>
          </div>

          <div
            className="col-12"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              marginBottom: "16px",
            }}
          >
            {otpDigits.map((digit, index) => (
              <input
                key={index}
                ref={this.otpRefs[index]}
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) => this.handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => this.handleOtpKeyDown(index, e)}
                onPaste={this.handleOtpPaste}
                style={{
                  width: "44px",
                  height: "52px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                  border: `1.5px solid ${digit ? "#007bff" : "#ced4da"}`,
                  borderRadius: "6px",
                  outline: "none",
                  transition: "border-color 0.15s",
                  backgroundColor: "#fff",
                  color: "#212529",
                }}
              />
            ))}
          </div>

          <div
            className="col-12 text-center mb-3"
            style={{ fontSize: "13px", color: timerColor, fontWeight: "500" }}
          >
            {isTimerExpired ? (
              <span
              style={{fontSize: "16px"}}
              >
                <Trans desc="Süre doldu">otp_expired</Trans>
              </span>
            ) : (
              // <span>{this.formatOtpTimer()}</span>
             <span
  style={{
    fontSize: "22px",
    fontWeight: "700",
    letterSpacing: "4px",
    fontVariantNumeric: "tabular-nums",
    background: otpTimer > 60
      ? "linear-gradient(135deg, #007bff, #0056b3)"
      : "none",
    WebkitBackgroundClip: otpTimer > 60 ? "text" : "unset",
    WebkitTextFillColor: otpTimer > 60 ? "transparent" : "unset",
    color: otpTimer <= 60 ? "#dc3545" : "unset",
    transition: "all 0.5s ease",
  }}
>
  {this.formatOtpTimer()}
</span>
            )}
          </div>

              <div
            className="col-12 text-center mb-2"
            style={{ fontSize: "13px", color: "#6c757d" }}
          >
            <Trans desc="Kod gelmedi mi?">otp_not_received</Trans>{" "}
            
             <a href="#"
              onClick={(e) => {
                e.preventDefault();
                this.handleResendOtp();
              }}
              style={{ color: "#007bff", textDecoration: "none" }}
            >
              <Trans desc="Tekrar Gönder">otp_resend</Trans>
            </a>
          </div>

          <div className="col-12 mt-3 text-right">
            <button
              type="submit"
              className="btn btn-fga-primary"
              disabled={isTimerExpired}
              style={isTimerExpired ? { opacity: 0.5, cursor: "not-allowed" } : {}}
            >
              <Trans desc="Doğrula">verify</Trans>
            </button>
          </div>
        </div>
      </form>
    );
  };


//   renderEmailVerificationForm = () => {
//   return (
//     <form
//       onSubmit={(e) => this.handleEmailVerificationSubmit(e)}
//     >
//       <div className="row">
//         {this.renderFormLogo()}
//         {this.renderError()}

 
//         <div className="col-12 text-center mb-3">
//           <h5><Trans desc="Email Doğrulama">email_verification</Trans></h5>
//           <p><Trans desc="Email adresine gelen kodu giriniz">enter_the_code_sent_to_your_email_address</Trans> </p>
//         </div>

//         <div className="col-12">
//           <input
//             type="text"
//             className="form-control"
//             placeholder={i18n.t("verification_code")} 
//             value={this.state.emailVerificationCode}
//             onChange={(e) =>
//               this.setState({ emailVerificationCode: e.target.value })
//             }
//           />
//         </div>

//         <div className="col-12 mt-3 text-right">
//           <button className="btn btn-primary">
//             <Trans desc="Doğrula">verify</Trans> 
//           </button>
//         </div>
//       </div>
//     </form>
//   );
// };


 renderPreLoginForm = () => {
    return (
      <form
        autoComplete="false"
        id="loginForm"
        name="loginForm"
        onSubmit={(e) => this.handlePreLoginSubmit(e)}
      >
        <div className="row h-100">
          {this.renderFormLogo()}
          {this.renderError()}
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="form-group" id="usernameArea">
              <label htmlFor="username">
                <Trans desc="Bayi E-posta Adresi">10355</Trans>
              </label>
              <input
                type="text"
                className="form-control"
                id="username"
                onChange={(e) => this.setState({ username: e.target.value })}
                value={this.state.username}
              />
              <div className="validationArea"></div>
            </div>
            <div className="form-group" id="passwordArea">
              <label htmlFor="password">
                <Trans desc="Şifre">10356</Trans>
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                onChange={(e) => this.setState({ password: e.target.value })}
              />
              <div className="validationArea"></div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 text-right pl-0">
            <a
              href="#"
              onClick={() =>
                this.setState({ form: LOGIN_FORMS.FORGOT_PASSWORD })
              }
            >
              <label className="formClickArea">
                <span className="iconmford fo-icon-lock-outline"></span>
                <span>
                  <Trans desc="Şifremi Unuttum">10357</Trans>
                </span>
              </label>
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mt-3 text-right">
            <button className="btn btn-fga-primary">
              <span>
                <Trans desc="Giriş Yap">10358</Trans>
              </span>
              <span className="iconmford fo-icon-exit-to-app"></span>
            </button>
          </div>
        </div>
      </form>
    );
  };

  renderPage = () => {
    return (
      <section style={{ position: "relative" }}>
        <div className="container-fluid p-0">
          <div className="row m-0">
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 p-0 d-none d-md-block d-lg-block">
              <div className="loginCoverArea">
                <div
                  className="loginCoverImg"
                  style={{
                    backgroundImage: this.state.bgImage,
                  }}
                ></div>
              </div>
            </div>
            {this.props.spinner}
            <div className="col-xs-12 col-sm-12 col-md-3 offset-md-1 col-lg-3 offset-lg-1 loginArea">
              {this.state.form === LOGIN_FORMS.SSO_CHECK && this.renderSSOCheckForm()}
              {this.state.form === LOGIN_FORMS.LOGIN && this.renderLoginForm()}

              {this.state.form === LOGIN_FORMS.PRELOGIN && this.renderPreLoginForm()} 
              {this.state.form === LOGIN_FORMS.PRELOGINEMAIL && this.renderEmailVerificationForm()}

              {this.state.form === LOGIN_FORMS.FORGOT_PASSWORD && this.renderForgotPasswordForm()}
              {this.state.form === LOGIN_FORMS.NEW_PASSWORD && this.renderNewPasswordForm()}
            </div>
          </div>
        </div>
      </section>
    );
  };

  render() {
    return this.renderPage();
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    generalProfile: state.profile.general,
    guide: state.guide,
  };
};

export default connect(mapStateToProps, {
  haveSSO,
  authenticate,
  sso,
  logOut,
  showModal,
  hideModal,
  approveKvkk,
  getProfileGeneral,
  getMailMatrix,
  sendEmailNotification,
  checkEmailCode,
  sendMobileNotification,
  checkMobileCode,
  resetPassword,
  saveNewPassword,
})(containsLongRunningProcess(Index));
